export default __webpack_public_path__ + "static/media/92.fb63cbe3.jpg";